import { render, staticRenderFns } from "./ProviderView.vue?vue&type=template&id=99387d46&"
import script from "./ProviderView.vue?vue&type=script&lang=js&"
export * from "./ProviderView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports